export default __webpack_public_path__ + "static/media/icon-4.477208cf.svg";